<template>
    <div class="table-container">
        <div class="title">
            <span>
                Recurring Viber Campaigns
            </span>
            <div>
                <v-btn
                    :disabled="!hasCreatePrivilege"
                    class="edit-btn"
                    @click="goToCreateRecurringViberCampaign()"
                >
                    Create New
                </v-btn>
            </div>
        </div>
        <array-view
            :items="viberCampaigns"
            :headers="headers"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :total-items="totalItems"
            :is-edit-disabled="!hasEditPrivilege"
            :is-delete-disabled="!hasDeletePrivilege"
            :is-fetching="isFetchingCampaigns"
            @refresh-data="refreshData"
            @paginationChange="paginationChange"
            @deleteCampaign="deleteCampaign"
            @updateCampaign="updateCampaignItem"
        />
    </div>
</template>

<script>
    import ArrayView from '@/components/ArrayView'
    import recurringViberCampaignService from '@/services/recurring-viber-campaign-service'
    import { hasPrivilege } from '@/utils/userUtils'
    import { PRIVILEGES } from '@/utils/consts'

    export default {
        components: { ArrayView },
        data() {
            return {
                headers: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'User',
                        value: 'username'
                    },
                    { text: 'Originator', value: 'originator' },
                    { text: 'Created At', value: 'createdAt' },
                    { text: 'Alias', value: 'alias' },
                    { text: 'TTL', value: 'ttl' },
                    { text: 'Fallback', value: 'fallback', align: 'center' },
                    { text: 'Actions', align: 'center', value: 'actions', sortable: false }
                ],
                viberCampaigns: [],
                totalPages: 0,
                size: 5,
                page: 1,
                totalItems: 0,
                isFetchingCampaigns: false
            }
        },
        computed: {
            hasDeletePrivilege() {
                return hasPrivilege(
                    PRIVILEGES.RECURRING_VIBER_CAMPAIGN_DELETE_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            },
            hasEditPrivilege() {
                return hasPrivilege(
                    PRIVILEGES.RECURRING_VIBER_CAMPAIGN_UPDATE_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            },
            hasCreatePrivilege() {
                return hasPrivilege(
                    PRIVILEGES.RECURRING_VIBER_CAMPAIGN_CREATE_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            }
        },
        watch: {
            page: 'applyFiltersToQuery',
            size: 'applyFiltersToQuery',
            sortKey: 'applyFiltersToQuery',
            sortOrder: 'applyFiltersToQuery'
        },
        created() {
            this.initializeFilters()
            this.fetchAllViberCampaigns()
        },
        methods: {
            refreshData() {
                this.fetchAllViberCampaigns()
            },
            paginationChange(page, size) {
                this.size = size
                this.page = page
                this.fetchAllViberCampaigns()
            },
            goToCreateRecurringViberCampaign() {
                this.$router.push('/recurring-viber/create')
            },
            fetchAllViberCampaigns() {
                this.isFetchingCampaigns = true
                recurringViberCampaignService.getAllViberCampaigns(this.page, this.size, this.sortKey, this.sortOrder)
                    .then(resp => {
                        this.viberCampaigns = resp.data.content || []
                        this.totalPages = resp.data.totalPages || 0
                        this.totalItems = resp.data.totalElements || 0
                    }).catch(error => {
                        console.error('Error fetching Recurring Viber Campaign:', error)
                    })
                    .finally(() => {
                        this.isFetchingCampaigns = false
                    })
            },
            deleteCampaign(id) {
                this.viberCampaigns = this.viberCampaigns.filter(campaign => campaign.id !== id)
            },
            updateCampaignItem(campaignIndex, property, val) {
                const campaign = this.viberCampaigns.find(c => c.id === campaignIndex)
                campaign[property] = val
            },
            initializeFilters() {
                const query = this.$route.query
                if (query.page) this.page = parseInt(query.page)
                if (query.pageSize) this.size = parseInt(query.pageSize)
                if (query.sortKey) this.sortKey = query.sortKey
                if (query.sortOrder) this.sortOrder = query.sortOrder
            },
            applyFiltersToQuery() {
                const query = {
                    page: this.page,
                    pageSize: this.size,
                    sortKey: this.sortKey,
                    sortOrder: this.sortOrder
                }
                this.$router.replace({ query })
            }
        }
    }
</script>

<style scoped>
    .title {
        font-size: 1.5rem !important;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
    }

    .edit-btn {
        text-transform: none !important;
        background: #00acd6 !important;
        color: white;
        margin: 15px auto;
    }

</style>
